const VIEWER_MODULE_URL = window.VIEWER_MODULE_URL;
let viewerModulePromise = null;

const DEFAULT_VMJ_URL = "https://cdn.shopify.com/s/files/1/0608/4060/7916/files/example.vmj?v=1777749513";

document.addEventListener("DOMContentLoaded", async () => {
  const params = new URLSearchParams(window.location.search);
  const vmjUrl = params.get("vmj");

  const dialog = document.getElementById("db-3d-template");
  const previewInner = document.querySelector(".preview-3d-inner");
  const customerEntry = document.getElementById("customer-preview-entry");
  const hideSections = document.querySelectorAll("[data-hide-on-vmj]");

  if (!dialog) return;

  dialog.dataset.vmjUrl = vmjUrl || DEFAULT_VMJ_URL;

  if (vmjUrl) {
    if (previewInner) previewInner.style.display = "none";
    if (customerEntry) customerEntry.style.display = "block";
    hideSections.forEach(el => el.style.display = "none");
    const title = dialog.querySelector("#title");
    if (title) title.textContent = "Your 3D Preview";
    const isValid = await isValidVmj(vmjUrl);
    if (!isValid) {
      console.warn("Invalid VMJ in URL, skipping modal");
      return;
    }
    await openModal(dialog);
  } else {
    if (previewInner) previewInner.style.display = "";
    if (customerEntry) customerEntry.style.display = "none";
     hideSections.forEach(el => el.style.display = "");
  }
});


function loadViewerModule(dialog) {
  if (!viewerModulePromise) {
    if (!VIEWER_MODULE_URL) {
        console.error("Missing viewer module URL");
        return;
    }
    viewerModulePromise = import(VIEWER_MODULE_URL);
  }
  return viewerModulePromise;
}

async function isValidVmj(url) {
  try {
    const res = await fetch(url, { method: "HEAD" });
    return res.ok;
  } catch (e) {
    return false;
  }
}

async function openModal(dialog) {
  if (typeof dialog.showModal !== "function") return;
  if (dialog.open) return;

  dialog.showModal();

  await new Promise(r => requestAnimationFrame(r));

  const url = dialog.dataset.vmjUrl || DEFAULT_VMJ_URL;
  if (!url) return;

  await loadViewerModule(dialog);

  const viewer = dialog.querySelector("db-3d-preview");

  if (viewer) {
    await customElements.whenDefined("db-3d-preview");

    const currentUrl = dialog.dataset.currentVmjUrl;

    if (currentUrl === url) return;

    const isValid = await isValidVmj(url);

    if (!isValid) {
      console.error("Invalid VMJ URL:", url);

      showPreviewError(dialog);

      return;
    }

    viewer.setVmjUrl(url);
    dialog.dataset.currentVmjUrl = url;
  }
}

function showPreviewError(dialog) {
  const viewer = dialog.querySelector("db-3d-preview");
  if (viewer) viewer.style.display = "none";

  let error = dialog.querySelector(".vmj-error");
  let caption = dialog.querySelector(".db-3d-preview_note");

  if (!error) {
    caption.style.display = "none";
    error = document.createElement("div");
    error.className = "vmj-error";
    error.innerHTML = `
      <p style="text-align:center; padding:40px;">
        ⚠️ Your 3D preview could not be loaded.<br>
        Please contact support.
      </p>
    `;
    dialog.querySelector(".db-3d-preview_modal-inner").appendChild(error);
  }
}

function closeModal(dialog) {
  dialog.close();
}

function onDocumentClick(event) {
  const opener = event.target.closest("[data-modal-open]");
  if (opener) {
    event.preventDefault();

    const targetId = opener.dataset.modalOpen;
    if (!targetId) return;

    const dialog = document.getElementById(targetId);
    if (!dialog || dialog.open) return;

    openModal(dialog);

    return;
  }

  const scrollBtn = event.target.closest("#scrollToOrder");
  if (scrollBtn) {
    event.preventDefault();

    const target = document.querySelector(".preview-order-wrapper");

    if (target) {
      const offset = 100;
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
    }

    return;
  }

  const closer = event.target.closest("[data-modal-close]");
  if (closer) {
    const dialog = closer.closest("dialog");
    if (dialog) {
      closeModal(dialog);
    }
    return;
  }

  if (
    event.target.tagName === "DIALOG" &&
    event.target.classList.contains("db-3d-preview_modal")
  ) {
    closeModal(event.target);
  }
}

document.addEventListener("click", onDocumentClick);